import { render, staticRenderFns } from "./Fruehstueck.vue?vue&type=template&id=249f271a&scoped=true"
import script from "./Fruehstueck.vue?vue&type=script&lang=js"
export * from "./Fruehstueck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f271a",
  null
  
)

export default component.exports